import { RouterModule } from '@angular/router';
import { HomeComponent } from './home.component';

export const homeRoutes=[
	{
        path:'',
        component:HomeComponent,      
    }
];


// WEBPACK FOOTER //
// C:/Users/Administrator/submit text project/gwin/src/app/home/home.routes.ts